import { useMutation } from '@tanstack/react-query';
import { IAddPromoCodeResponse, IEditPromoBody } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const addPromo = async (body: IEditPromoBody) => {
  const res = await apiManager.post<IAddPromoCodeResponse>(
    "/promoCode/addPromoCode",
    body
  );
  return res;
};

export const useAddPromo = () =>
  useMutation({
    mutationFn: async (body: IEditPromoBody): Promise<IAddPromoCodeResponse> => {
      const res = await apiClient.post(ENDPOINTS.PROMO_CODES.ADD_PROMO_CODE, body);
      return res.data;
    },
  });